var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment"},[_c('h4',{staticClass:"payment__title"},[_vm._v(" Forma de pagamento ")]),_c('h5',{staticClass:"payment__method"},[_vm._v(" "+_vm._s(_vm._f("formatMethod")(_vm.name))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }